import * as React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

interface GeneratingDialogProps {
	isOpen: boolean;
	onOpenChange: (open: boolean) => void;
	platform: 'twitterx' | 'linkedin';
}

export function GeneratingDialog({
	isOpen,
	onOpenChange,
	platform,
}: GeneratingDialogProps) {
	const content = {
		twitterx: {
			emoji: '𝕏',
			title: 'Generating Tweet...',
			description: 'Crafting the perfect tweet for your audience',
		},
		linkedin: {
			emoji: '💼',
			title: 'Generating LinkedIn Post...',
			description: 'Creating professional content for your network',
		},
	};

	const platformContent = content[platform];

	return (
		<Dialog open={isOpen} onOpenChange={onOpenChange}>
			<DialogContent className='sm:max-w-md'>
				<DialogTitle className='sr-only'>
					{platformContent.title}
				</DialogTitle>
				<div className='flex flex-col items-center justify-center py-8 space-y-4'>
					<img
						src='/logo.png'
						alt='Prometheus'
						className='h-12 mb-4'
					/>
					<motion.div
						animate={{
							scale: [1, 1.2, 1],
							rotate: [0, 360],
						}}
						transition={{
							duration: 2,
							repeat: Infinity,
							ease: 'easeInOut',
						}}
						className='text-6xl'
					>
						{platformContent.emoji}
					</motion.div>
					<motion.div
						initial={{ opacity: 0, y: 10 }}
						animate={{ opacity: 1, y: 0 }}
						className='text-xl font-semibold text-purple-500'
					>
						{platformContent.title}
					</motion.div>
					<div className='flex items-center gap-2'>
						<Loader2 className='h-4 w-4 animate-spin text-purple-500' />
						<span className='text-sm text-gray-500'>
							This may take a moment
						</span>
					</div>
					<motion.div
						animate={{
							opacity: [0.5, 1, 0.5],
						}}
						transition={{
							duration: 2,
							repeat: Infinity,
							ease: 'easeInOut',
						}}
						className='text-sm text-gray-400'
					>
						✨ {platformContent.description} ✨
					</motion.div>
				</div>
			</DialogContent>
		</Dialog>
	);
}
